import { Button, Modal, Stack, Text, List } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { camelCaseOrSnakeCaseToWords } from '../merge-review/ReviewHelperFunctions';

type Props = {
  opened: boolean;
  close: () => void;
  validationErrors: { entityType: string; reason: string }[];
};

export function ValidationErrorsModal({ opened, close, validationErrors }: Props) {
  return (
    <Modal
      opened={opened}
      onClose={close}
      title={
        <Text size="displayXs" fw={FONT_WEIGHTS.bold} c="gray.10">
          Cannot Import
        </Text>
      }
    >
      <Stack gap="md">
        <Text size="textSm" c="gray.7">
          Please review and add the missing information before importing:
        </Text>

        <List spacing="xs">
          {validationErrors.map((error, index) => (
            <List.Item key={index}>
              <Text size="textSm" fw={FONT_WEIGHTS.medium}>
                <Text span fw={FONT_WEIGHTS.semibold} c="gray.10">
                  {camelCaseOrSnakeCaseToWords(error.entityType)}:
                </Text>{' '}
                {error.reason}
              </Text>
            </List.Item>
          ))}
        </List>

        <Button variant="secondary" size="md" onClick={close} fullWidth>
          Close
        </Button>
      </Stack>
    </Modal>
  );
}
